import { useEffect, useState } from 'react';

const SECTION_IDS = ['hero', 'about', 'renewable', 'financing', 'bess', 'projects', 'news'];

/** Returns the id of the section currently in view using IntersectionObserver. */
export function useActiveSection() {
  const [activeSection, setActiveSection] = useState('hero');

  useEffect(() => {
    const observers = SECTION_IDS.map((id) => {
      const el = document.getElementById(id);
      if (!el) return null;
      const obs = new IntersectionObserver(
        ([entry]) => { if (entry.isIntersecting) setActiveSection(id); },
        { rootMargin: '-35% 0px -55% 0px', threshold: 0 }
      );
      obs.observe(el);
      return obs;
    });
    return () => observers.forEach((o) => o?.disconnect());
    // SECTION_IDS is a module constant; IntersectionObserver is a browser global;
    // setActiveSection is a stable useState dispatcher
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return activeSection;
}
